import { Component, ChangeDetectionStrategy, input, computed, inject } from '@angular/core';
import { IrisDMSFolderI } from '@iris/common/modules/dms/models/IrisDMSFolder';
import { IrisColorService } from '@iris/common/services/color.service';

@Component({
  selector: 'iris-folder-svg',
  templateUrl: './folder-svg.component.html',
  styleUrls: ['./folder-svg.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisFolderSvgComponent {
  private readonly colorService = inject(IrisColorService);

  readonly folder = input<IrisDMSFolderI>();
  readonly width = input<number>();
  readonly height = input<number>();
  readonly color = input<string>();
  readonly hasChildren = input<boolean>();

  readonly defaultFolderColor = this.colorService.colors.$warning;

  readonly folderColor = computed(() => this.color() || this.folder()?.color || this.defaultFolderColor);
  readonly isFolderOrSubFoldersHasFiles = computed(() => {
    return this.hasChildren()
      || !!this.folder()?.hasFiles
      || this.folder()?.children?.some(({ hasFiles }) => hasFiles);
  });
}
